'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function serializeValue(key, value) {
  return encodeURIComponent(key) + '=' + encodeURIComponent(value == null ? '' : value);
}

function serializeArray(key, value) {
  return value.reduce(function (result, current) {
    // mimic the default jQuery behavior here
    if (current != null) {
      result.push(serializeValue('' + key, current));
    }
    return result;
  }, []).join('&');
}

var stringify = exports.stringify = function stringify(query) {
  if (query == null) return '';
  if (typeof query === 'string' || query instanceof String) return query;
  return Object.keys(query).reduce(function (result, key) {
    var value = query[key];
    if (Array.isArray(value)) {
      if (value.length > 0) result.push(serializeArray(key, value));
    } else if (value != null) {
      result.push(serializeValue(key, value));
    }
    return result;
  }, []).join('&');
};

var parse = exports.parse = function parse(query) {
  if (query == null || query.trim() === '') {
    return {};
  }

  return query.split('&').reduce(function (result, current) {
    var _current$split = current.split('='),
        _current$split2 = _slicedToArray(_current$split, 2),
        key = _current$split2[0],
        value = _current$split2[1];

    var keyName = key;
    var decodedValue = decodeURIComponent(value);

    // parse query strings in the form foo[] for arrays. This is only for compatibility and
    // repeating keys should be favored.
    if (keyName.length > 2 && keyName.lastIndexOf('[]') === keyName.length - 2) {
      keyName = keyName.substring(0, keyName.length - 2);
    }

    var existing = result[keyName];
    if (existing !== undefined) {
      if (Array.isArray(existing)) {
        existing.push(decodedValue);
      } else {
        result[keyName] = [existing, decodedValue];
      }
    } else {
      result[keyName] = decodedValue;
    }

    return result;
  }, {});
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.179/js/helpers/params.js
// module id = 121
// module chunks = 2 3